import {Tone} from "../../../../components/kit";

/** Etiquetas en español de la formación (#13719, #13886). */

export const TRAINING_KIND_LABELS: Record<string, string> = {
	FORMACION: "Formación",
	CONCIENCIACION: "Concienciación",
};

export const TRAINING_STATUS: Record<string, { label: string, tone: Tone }> = {
	PLANIFICADA: {label: "Planificada", tone: "info"},
	REALIZADA: {label: "Realizada", tone: "success"},
	CANCELADA: {label: "Cancelada", tone: "neutral"},
};
